import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CollectionNavItemFragment = { __typename?: 'Collection', id: string, name: string, private?: boolean | null, creator?: { __typename?: 'AuthenticatedUser', id: string } | null, appearance: { __typename?: 'AssetAggregateAppearance', header?: { __typename?: 'AssetAggregateAppearanceHeader', iconEmoji?: string | null, isIconEnabled?: boolean | null } | null } };

export const CollectionNavItem = /*#__PURE__*/ gql`
    fragment CollectionNavItem on Collection {
  creator {
    id
  }
  id
  name
  private
  appearance {
    header {
      iconEmoji
      isIconEnabled
    }
  }
}
    ` as unknown as DocumentNode<CollectionNavItemFragment, unknown>;

        

        
export const useCollectionNavItemFragment = (
  input: string | Omit<UseFragmentOptions<CollectionNavItemFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Collection' } };
    return input;
  })();

  return useFragment<CollectionNavItemFragment>({
    fragment: CollectionNavItem,
    fragmentName: 'CollectionNavItem',
    ...options,
  });
};
  
        